import { styled } from '@mui/system'
import { Card, Stack } from '@mui/material'

const Container = styled(Card)`
  flex: 4;
  display: flex;
  flex-direction: column;
`

const Body = styled(Stack)`
  flex: 1;
  align-items: center;
  justify-content: center;
`

export { Container, Body }
